/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum OrderType {
    DUTCH_LIMIT = 'DutchLimit',
    DUTCH = 'Dutch',
    DUTCH_V2 = 'Dutch_V2',
}
